<script>
import BusienssService from "@/services/Business";
import Customers from "@/services/Customers";
import Swal from "sweetalert2";

export default {
  props: {
    existingCompanyIds: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    availableCompanies() {
      const existing = new Set((this.existingCompanyIds || []).map(String));
      return (this.companies || []).filter(
        (company) => !existing.has(String(company.company_id))
      );
    },
    companyOptions() {
      return this.availableCompanies.map((company) => ({
        text: company.name,
        value: company.company_id,
      }));
    },
  },

  data() {
    return {
      // editableBusinessWall: {}, // Local copy for editing
        companies: [],
        selectedCompany: null,
        is_highlighted: 0,
        errorMessage:'',
        saving: false,
    };
  },
    methods: {
      async getAllCompanies(){
          try {

              this.toggleBusy();

              const response = await Customers.getCompanies()
              this.companies = response.data.data
          } catch (error) {
              this.error = error.response.data.error ? error.response.data.error : "";
              this.companies = []
          } finally {
              this.toggleBusy();
          }
      },
    async saveChanges() {
      if (this.saving) {
        return;
      }

      if (!this.selectedCompany) {
        this.errorMessage = "Please select a company";
        return;
      }
        const data = {
            "company_id": this.selectedCompany,
            "is_highlighted": this.is_highlighted,
        }


      try {
        this.saving = true;
        this.errorMessage = '';
        const response = await BusienssService.addCompanyToBusinessWall(data);
        if (response.status >= 200 && response.status < 300) {
          // Emit event for parent to update after save
          // this.$emit('update-success', this.editableBusinessWall);
          this.$emit('onRefresh');  // Emit refreshTable only after saving
          this.$bvModal.hide('add_company_to_business_wall');  // Close the modal after save
          Swal.fire("Success", "Company added to business wall.", "success");

        } else {
            throw new Error('Failed to save changes');
        }
      } catch (error) {
          const message = error?.response?.data?.error || error?.message || "Error saving changes. Please try again.";
          this.errorMessage = Array.isArray(message) ? message.join(", ") : message;
          Swal.fire("Error", this.errorMessage, "error");
        // alert("Error saving changes. Please try again.");
      } finally {
        this.saving = false;
      }
    },

    closeModal() {
      // Only hide the modal, no page reload or table refresh here
      if (this.saving) {
        return;
      }
      this.$bvModal.hide('add_company_to_business_wall');
      this.errorMessage=''
      this.selectedCompany=null
      this.is_highlighted = 0
    },


  },
  mounted() {
      this.getAllCompanies()
  }

};
</script>

<template>
  <b-modal id="add_company_to_business_wall" title="Add Company To Business Wall" @hidden="closeModal" size="md" centered>
    <template v-slot:default>
      <div class="row">
        <div class="col-12">
          <b-form-group label="Company">
              <b-form-select
                      v-model="selectedCompany"
                      :options="companyOptions"
                      placeholder="Select a company">
              </b-form-select>
              <small v-if="companyOptions.length === 0" class="text-muted d-block mt-2">
                All active companies are already added to the business wall.
              </small>
          </b-form-group>
            <b-form-group label="Is Highlighted">
                <div class="form-check form-switch form-switch-lg" dir="ltr">
                    <input
                            v-model="is_highlighted"
                            type="checkbox"
                            class="form-check-input"
                    />
                </div>
            </b-form-group>
            <p class="text-danger" v-if="errorMessage">{{errorMessage}}</p>
        </div>
      </div>
    </template>
    <template v-slot:modal-footer style="justify-content: flex-start">
      <b-button variant="light" :disabled="saving" @click="closeModal">Cancel</b-button>
      <b-button variant="primary" :disabled="saving" @click="saveChanges">
        <b-spinner v-if="saving" small class="me-1"></b-spinner>
        {{ saving ? "Saving..." : "Save Changes" }}
      </b-button>
    </template>
  </b-modal>
</template>
